/* eslint-disable no-nested-ternary */
/* eslint-disable max-lines */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useI18n, Bullet, Bubbles } from '@popety_io/popety-io-lib'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import Paper from '@mui/material/Paper'
import MouseHoverPopover from '../../../../components/MouseHoverPopover'

import GridHeader from '../Configuration/GridHeader'
import LandScore from '../../../../components/LandScore'
import { getScoreConfidenceData } from './utils'

const optionsSettings = () => [
  {
    color: 'rgba(127, 188, 83, 0.7)',
    value: 3,
    text: 'Text 1',
    fillCount: 3,
  },
  {
    color: 'rgb(233, 123, 14)',
    value: 2,
    text: 'Text 2',
    fillCount: 2,
  },
  {
    color: 'rgba(177, 73, 69, 0.7)',
    value: 1,
    text: 'Text 3',
    fillCount: 1,
  },
]

const DeveloppementPotentiel = ({ data }: { data: Record<string, any> }) => {
  const options = optionsSettings()

  const confidence = getScoreConfidenceData(data?.indice_used)

  const { t } = useI18n()

  const indice =
    data?.indice_used === 'from_pq'
      ? t('common.underExploited.score.Indice.from_pq')
      : t(
          `common.underExploited.score.Indice${
            data?.indice_used?.endsWith('estimate')
              ? '.estimate'
              : data?.indice_used?.endsWith('overide')
                ? '.overide'
                : ''
          }`,
          { indice: data?.indice_used?.split('_')[0]?.toUpperCase() },
        )

  const bulletValue = confidence?.value
  const scoreBullet = confidence?.data

  return (
    <Box
      sx={{
        marginTop: '10px',
      }}
    >
      <GridHeader title={t('common.POTENTIEL DE DEVELOPPEMENT')} />
      <Box
        sx={{
          padding: '6px',
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={6}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <LandScore
                score={data.under_exploited_score}
                title={t('land.devScore.developmentScoreDesc')}
                showScoreLegend={false}
              />
              <MouseHoverPopover
                sx={{
                  display: 'flex',
                  gap: '2px',
                }}
                title={
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      sx={{
                        color: '#969696',
                        fontSize: '1rem',
                        fontWeight: '500',
                      }}
                    >
                      {t('land.underExploitedScore')}
                    </Typography>
                  </Box>
                }
              >
                <Paper
                  sx={{
                    padding: 2,
                    width: 'fit-content',
                    maxWidth: '300px',
                  }}
                >
                  <span style={{ fontSize: '1.1rem' }}>
                    {t('land.underExploited.underExploitedDesc')}
                  </span>
                </Paper>
              </MouseHoverPopover>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                paddingBottom: '5px',
                paddingTop: '5px',
                height: '100%',
              }}
            >
              <Box>
                <Typography
                  sx={{
                    fontSize: '0.9rem',
                  }}
                >
                  {t('common.Fiabilité')}
                </Typography>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                  }}
                >
                  <Bullet
                    // title={t('common.score.bullet.text')}
                    data={scoreBullet}
                    value={bulletValue}
                  />
                  <Typography
                    sx={{
                      color: '#969696',
                      fontSize: '0.8rem',
                    }}
                  >
                    {indice}
                  </Typography>
                  <MouseHoverPopover
                    sx={{
                      display: 'flex',
                      gap: '2px',
                    }}
                  >
                    <Paper
                      sx={{
                        padding: 2,
                        width: 'fit-content',
                        maxWidth: '600px',
                        'div > span': {
                          marginLeft: '12px',
                          padding: '3px',
                        },
                      }}
                    >
                      <Typography variant="h6">
                        {t('common.score.bullet.text')}
                      </Typography>
                      {scoreBullet.map((item) => (
                        <Box key={item.value} display="flex" gap="2px">
                          <Bubbles data={scoreBullet} value={item.value} />
                          <Typography component="span" color="text.secondary">
                            {item.text}
                          </Typography>
                        </Box>
                      ))}
                    </Paper>
                  </MouseHoverPopover>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}

export default DeveloppementPotentiel
